module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_7005.b8672b40.png";